exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-0414c1bc]{border:1px solid #ddd;border-radius:8px;margin:10px;overflow:hidden;box-shadow:0 4px 8px rgba(0,0,0,.1);transition:transform .3s ease,opacity .5s ease}.card[data-v-0414c1bc]:hover{transform:scale(1.05)}.card-header[data-v-0414c1bc]{background-color:#3498db;color:#b90f0f;padding:10px;font-weight:700}.card-body[data-v-0414c1bc]{padding:15px}.client-details[data-v-0414c1bc]{margin-top:10px;color:#555}a[data-v-0414c1bc]{color:#3498db;text-decoration:none;font-weight:700}a[data-v-0414c1bc]:hover{text-decoration:underline}.fade-in[data-v-0414c1bc]{opacity:0}.fade-in-enter-active[data-v-0414c1bc]{transition:opacity .5s}.fade-in-enter-to[data-v-0414c1bc]{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0414c1bc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/brfCard.vue
// module id = 1348
// module chunks = 0